import { SET_ENQUIRY_CONVERT, CLEAR_ENQUIRY_CONVERT } from "../actions/enquiryConvert";

const initialState = { data: null };

export default function enquiryConvert(state = initialState, action) {
  switch (action.type) {
    case SET_ENQUIRY_CONVERT:
      return { data: action.payload };
    case CLEAR_ENQUIRY_CONVERT:
      return { data: null };
    default:
      return state;
  }
}
